import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_precision-cookware/artifacts/dp89k0mx_Texstyle%20Logo.png";

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'nav-scrolled' : 'nav-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a 
            href="/" 
            data-testid="nav-logo"
            className="flex items-center gap-3 group"
          >
            <img 
              src={LOGO_URL} 
              alt="Tex-Style Company Bird Logo" 
              className="h-14 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <span className="font-cormorant text-2xl text-white tracking-wide">
              Tex-Style Company
            </span>
          </a>

          {/* Navigation Links - Removed "The Craft" */}
          <div className="hidden md:flex items-center gap-8">
            <a
              href="https://shop.texstyleco.com"
              data-testid="nav-collections"
              className={`font-raleway text-[11px] font-semibold uppercase tracking-ultra transition-colors duration-300 ${
                isActive('/shop') ? 'text-tex-violet-bright' : 'text-tex-warm-white hover:text-tex-violet-bright'
              }`}
            >
              Collections
            </a>
            <a
              href="https://shop.texstyleco.com/collection/contact/"
              data-testid="nav-contact"
              className="font-raleway text-[11px] font-semibold uppercase tracking-ultra bg-tex-violet text-white px-6 py-3 rounded-full hover:bg-tex-violet-bright transition-all duration-300 hover:shadow-[0_0_20px_rgba(107,68,204,0.4)]"
            >
              Contact
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            data-testid="mobile-menu-btn"
            className="md:hidden text-white p-2"
            aria-label="Menu"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-tex-bg/98 backdrop-blur-lg border-t border-white/5 py-6 px-6">
            <nav className="flex flex-col gap-4">
              <a
                href="https://shop.texstyleco.com"
                className="font-raleway text-sm font-semibold uppercase tracking-wide text-tex-warm-white hover:text-tex-violet-bright transition-colors py-2"
              >
                Collections
              </a>
              <a
                href="https://shop.texstyleco.com/collection/contact/"
                className="font-raleway text-sm font-semibold uppercase tracking-wide bg-tex-violet text-white px-6 py-3 rounded-full text-center hover:bg-tex-violet-bright transition-all"
              >
                Contact
              </a>
            </nav>
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
